(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mq-garage-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){var link=event.target.closest('.mq-mobile-nav a');if(link){var menu=link.closest('details');if(menu){menu.removeAttribute('open');}}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mq-garage-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){var link=event.target.closest('[data-mq-topic]');if(!link){return;}var home=link.closest('[data-mq-home]');if(!home){return;}var select=home.querySelector('[data-mq-topic-select]');if(select){select.value=link.getAttribute('data-mq-topic');select.dispatchEvent(new Event('change',{bubbles:true}));}});

  } catch(e) { console.error(e); }
})();
})();
